import { useEffect, useState } from 'react';
import { contactApiKeyStore } from '../../../../api/contact-api-key-store';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { useFileDownload } from '../../../../components/file-download';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { useLoadData } from '../../../../hooks/useLoadData';
import { useSaveData } from '../../../../hooks/useSaveData';
import { Contract } from '../../../../models/contract';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { columns } from './grid-columns';
import useDebounce from '../../../../hooks/use-debounce';
import { State } from '@progress/kendo-data-query';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import { ApiResponse } from '../../../../models/api-response';

interface ContractsTab {
  contracts: Contract[];
}
export const ContractsTab = ({ contracts }: ContractsTab) => {
  const { error, downloadFile, isLoading } = useFileDownload();
  const handleDownloadFile = async (data: any) => {
    downloadFile({ additionalData: data });
  };

  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout,
  } = useLoadData<ApiResponse<GridPreference>>(gridApiKeyStore.getGridLayout('Customer Details', 'Contracts'));

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredContracts, setFilteredContracts] = useState<Contract[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredContractList = contracts.filter((contarct) =>
      Object.values(contarct).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredContracts(filteredContractList || []);
  }, [debouncedSearchTerm, contracts]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'Contracts',
      pageName: 'Customer Details',
    };
    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'Contracts',
      pageName: 'Customer Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };
  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      //   if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      //   }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);

  return (
    <SiTrackGrid
      fileTitle='customer_contract'
      //   dataItems={contracts}
      dataItemKey="contractID"
      columns={columns}
      onDownload={(data: any) => {
        handleDownloadFile(data);
      }}
      actionPermissions={{
        download: UserPermissionName.DOWNLOAD_CONTRACT_CUSTOMER,
        export: UserPermissionName.DOWNLOAD_GRID,
      }}
      isBusy={isLoading}
      // -----------------Grid Layout-------
      dataItems={filteredContracts || []}
      reorderable
      handleSearch={handleInputChange}
      handleSaveLayout={handleSaveLayout}
      isSaveLayout={true}
      gridConfigFromApi={gridConfig}
      handleResetLayout={handleResetLayout}
    // -----------------Grid Layout-------
    />
  );
};
